// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalBodySelector } from "@hardwoods/XDL/PreStyle/modal";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { styledScrollbar } from "@hardwoods/XDL/Utilities/SharedStyles";
import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalContent: css`
            overflow: hidden;
            ${modalBodySelector} {
                overflow: auto;
                ${styledScrollbar()}
            }
        `,
    },
};

scheduleReminderModalStyles.contentContainer = {
    gap: 20,
    css: css`
        max-height: 428px;
    `,
};

scheduleReminderModalStyles.hintText = {
    size: 15,
    weight: "normal",
    css: css`
        line-height: 22px;
        margin-top: 5px;
    `,
};

scheduleReminderModalStyles.middleRowLeftColumnGridItem = {
    width: [12, 12, 6, 7, 7],
};

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: [12, 12, 6, 5, 5],
};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-top: 60px;
        padding-bottom: 20px;
    `,
};

scheduleReminderModalStyles.cancelButtonGridItem = {
    css: css`
        justify-content: flex-end;
        max-width: initial;
        flex-basis: auto;
        ${xScreen.lte("xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.stopButton = {
    ...scheduleReminderModalStyles.stopButton,
    variant: "tertiary",
};

scheduleReminderModalStyles.cancelButton = {
    ...scheduleReminderModalStyles.cancelButton,
    variant: "tertiary",
};

scheduleReminderModalStyles.monthlyRadio = {
    css: css`
        & + & {
            margin-top: 0;
            margin-left: 0;
        }
    `,
};

scheduleReminderModalStyles.weeklyRadio = {
    css: css`
        & + & {
            margin-top: 0;
            margin-left: 0;
        }
        input {
            margin-left: 0;
        }
    `,
};

scheduleReminderModalStyles.scheduleButtonGridItem = {
    css: css`
        justify-content: flex-end;
        max-width: initial;
        flex-basis: auto;
        ${xScreen.lte("xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
